import { useCallback } from 'react';
import { useTrack } from '@frameio/shared/segment/hooks';
import { Badge, MenuButton, theme } from '@frameio/vapor';
import { IconPrimaryNavMegaphoneFill } from '@frameio/vapor-icons';
import { useAppSheetButton } from '../../../hooks';
import { useWhatsNew } from '../../AppSheet/Sheets/WhatsNewSheet/WhatsNewContext';
import TEXT from './generated/TEXT/WhatsNewMenuItem';

TEXT.DEFINE({
  /** Help and support menu item label */
  label: "What's New",
});

const sheetId = 'whats-new';

export const WhatsNewMenuItem = () => {
  const { props: bind } = useAppSheetButton(sheetId);
  const { hasUpdatesSinceLastViewed } = useWhatsNew();
  const track = useTrack();

  const onClick = useCallback(() => {
    track('whats-new-panel-opened');
  }, [track]);

  return (
    <MenuButton
      data-dd-action-name="primary-nav.whats-new"
      iconBefore={
        <Badge
          backgroundColor="error"
          borderColor={theme.colors.components.sheet.background}
          borderSize={2}
          data-testid="whats-new-button-badge"
          isShowing={hasUpdatesSinceLastViewed()}
          label="label"
          placement="top-right"
        >
          <IconPrimaryNavMegaphoneFill />
        </Badge>
      }
      {...bind}
      aria-controls="app-sheet"
      aria-expanded={bind['aria-expanded']}
      onClick={onClick}
    >
      {TEXT.label}
    </MenuButton>
  );
};
